<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex>
        <slot name="page-header" />
        <v-row no-gutters>
          <v-col>
            <slot name="domains-list-toolbar" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <slot name="domains-list" />
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DomainsLayout extends Vue {
}
</script>
